export default function selected(target,url, selectedItems){
    if(target.classList.contains('image-picker-selected')){
        target.classList.remove('image-picker-selected');
        if(selectedItems.includes(url)){
            
            const index = selectedItems.indexOf(url);
            if (index > -1) {
                selectedItems.splice(index, 1);
            }
        }
    }else{
        target.classList.add('image-picker-selected');
        if(!selectedItems.includes(url)){
            selectedItems.push(url);
        }
    }  
    sessionStorage.setItem('selected_item', JSON.stringify(selectedItems));
}